import tokenAbi from "./DssToken.json"
import PackageAbi from "./DssPackage.json"

// export const contractAddressDssToken = "0x703c35F6eb4Fe4C8Fc1620e292bf83dF7566376E"; //test
export const contractAddressDssToken = "0xfC5b1a1151df4105e7F7334195d1675B81879311";    //main
export const abiDssToken = tokenAbi
// export const contractAddressDssPackage = "0x98C79cfC7677ccC372588180671EAAa65BE7aA67"; //test
export const contractAddressDssPackage = "0x95df3a0cBFD0eEcdE9eedaBF8aB2c8fd9B61efae";  //main
export const abiDssPackage = PackageAbi
